import { OrganisationPageRouteBuilder } from "@org-common/lib/route/organisation-page-route-builder";
import { CumulusComponentsPageComponent } from "./cumulus-components-page.component";

export const cumulusComponentsPageRoute = new OrganisationPageRouteBuilder()
    .usingNgComponent("adapt-cumulus-components-page", CumulusComponentsPageComponent)
    .atUrl("/about/theme-test/cumulus-components")
    .requiresLogin(true)
    .build();
